export const CONFIG = {
    baseApiHost: 'https://ft6qcivoxh.execute-api.ap-south-1.amazonaws.com/api'    
}